module.exports = __webpack_public_path__ + "assets/fbdc5a19032dfa657580e45701d7b35d.png";